import { useRouter } from 'expo-router';
import { InformationScreenTypeEnum } from 'features/otp/information/InformationScreenTypeEnum';
import { getMaxLimitErrorResponse } from 'shared/utils/errors/getMaxLimitErrorResponse';

export const navigateToMaxLimitError = (
  router: ReturnType<typeof useRouter>,
  error: unknown,
): boolean => {
  const maxLimitResponse = getMaxLimitErrorResponse(error);

  if (!maxLimitResponse) {
    return false;
  }

  router.navigate({
    pathname: '/otp/error',
    params: {
      screenType: InformationScreenTypeEnum.MaxLimitReached,
      title: maxLimitResponse.title,
      message: maxLimitResponse.message,
    },
  });

  return true;
};
